import styled from 'styled-components';

import { blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const Sponsors = styled.section`
  /* background: ${blackSphera}; */
  padding: 6% 0;

  > h2 {
    font-size: 3vw;
    /* color: ${whiteSphera}; */
    color: ${blackSphera};
    text-align: center;
    margin-bottom: 2.5%;
  }

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 95%;
    gap: 2.5%;
    margin: auto;

    > a {
      > figure {
        background-color: ${whiteSphera};
        > img {
          width: 100%;
          height: 100%;
          /* filter: grayscale(1); */
        }
      }
    }

    > a:nth-child(1) {
      width: 20%;
    }

    > a:nth-child(2) {
      width: 12%;
    }

    > a:nth-child(3) {
      width: 15%;
    }

    > a:nth-child(4) {
      width: 18%;
    }

    > a:nth-child(5) {
      width: 15%;
    }

    > a:nth-child(6) {
      width: 20%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
    }

    > div {
      > a {
        > figure {
          > img {
          }
        }
      }

      > a:nth-child(1) {
      }

      > a:nth-child(2) {
      }

      > a:nth-child(3) {
      }

      > a:nth-child(4) {
      }

      > a:nth-child(5) {
      }

      > a:nth-child(6) {
      }
    }
  }

  @media (max-width: 600px) {
    padding: 8% 0;

    > h2 {
      font-size: 5vw;
      margin-bottom: 5%;
    }

    > div {
      > a {
        > figure {
          > img {
          }
        }
      }

      > a:nth-child(1) {
      }

      > a:nth-child(2) {
      }

      > a:nth-child(3) {
      }

      > a:nth-child(4) {
      }

      > a:nth-child(5) {
      }

      > a:nth-child(6) {
      }
    }
  }
`;
